/**
 * @generated SignedSource<<ed8fda6f3763fe5eae10e6832fab2f37>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateImagePageInput = {
  clientMutationId?: string | null;
  image: string;
  internalTitle: string;
  messageDefinitionId: string;
};
export type useMessagePageMutations_CreateImagePageMutation$variables = {
  input: CreateImagePageInput;
};
export type useMessagePageMutations_CreateImagePageMutation$data = {
  readonly Admin: {
    readonly MessageDefinitions: {
      readonly createImagePage: {
        readonly messageDefinition: {
          readonly node: {
            readonly id: string;
          };
        };
        readonly pageId: string;
      } | null;
    };
  };
};
export type useMessagePageMutations_CreateImagePageMutation = {
  response: useMessagePageMutations_CreateImagePageMutation$data;
  variables: useMessagePageMutations_CreateImagePageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageDefinitionsAdminMutationSchema",
        "kind": "LinkedField",
        "name": "MessageDefinitions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "CreateImagePagePayload",
            "kind": "LinkedField",
            "name": "createImagePage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pageId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MessageDefinitionsEdge",
                "kind": "LinkedField",
                "name": "messageDefinition",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MessageDefinition",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMessagePageMutations_CreateImagePageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMessagePageMutations_CreateImagePageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f7bd13b533d7cde550f037478d1d34cf",
    "id": null,
    "metadata": {},
    "name": "useMessagePageMutations_CreateImagePageMutation",
    "operationKind": "mutation",
    "text": "mutation useMessagePageMutations_CreateImagePageMutation(\n  $input: CreateImagePageInput!\n) {\n  Admin {\n    MessageDefinitions {\n      createImagePage(input: $input) {\n        pageId\n        messageDefinition {\n          node {\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f8b4d6dd1517bf79911b097af85e00ca";

export default node;
